"use client";

import React, { useEffect, useState, useRef } from "react";
import Image from "next/image";
import Link from "next/link";
import Navbar from "/components/Shufflemaps/Navbar/Navbar";
import headerStyles from "./Header.module.css";

/**
 * ShuffleMaps Header
 * - Auto-hides on scroll down / shows on scroll up
 * - Subtitle and logo are grouped so the logo appears immediately to the right of the tagline
 * - Safe defaults for i18n
 */
export default function Header({
  language = "en",
  setLanguage = () => {},
  i18n = {},
  availableLanguages = [],
}) {
  const [hideHeader, setHideHeader] = useState(false);
  const lastScrollRef = useRef(0);
  const threshold = 40;

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll - lastScrollRef.current > threshold) {
        setHideHeader(true);
        lastScrollRef.current = currentScroll;
      } else if (lastScrollRef.current - currentScroll > threshold) {
        setHideHeader(false);
        lastScrollRef.current = currentScroll;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const tHeader = i18n?.header || {};

  return (
    <>
      {/* Top header bar */}
      <header
        className={`${headerStyles.header} ${
          hideHeader ? headerStyles.hideHeader : ""
        }`}
      >
        <div className={headerStyles.headerContent}>
          {/* Title on the LEFT */}
          <div className={headerStyles.title}>
            <Link className={headerStyles.siteName} href="/ShuffleMaps">
              <span className={headerStyles.titleText}>SHUFFLEMAPS.COM</span>
            </Link>
          </div>

          {/* Tagline + Logo grouped; logo appears immediately to the right of tagline */}
          <div className={headerStyles.subtitleLogoWrap}>
            <div className={headerStyles.subtitle}>
              <span className={headerStyles.subtitleText}>
                {tHeader?.subtitleLine1 || "a community platform for"}
              </span>
              <span className={headerStyles.highlight}>
                {tHeader?.subtitleLine2 || "Classes & Meetups."}
              </span>
            </div>

            <Link href="/ShuffleMaps" className={headerStyles.logo} aria-label="ShuffleMaps home">
              <div className={headerStyles.logoContainer}>
                <Image
                  src="/Shufflemaps-Assets/icon3.png"
                  alt="ShuffleMaps Logo"
                  fill
                  sizes="(max-width: 480px) 40px, (max-width: 768px) 50px, 96px"
                  style={{ objectFit: "contain" }}
                  priority
                />
              </div>
            </Link>
          </div>
        </div>
      </header>

      {/* Main navbar */}
      <Navbar
        hideHeader={hideHeader}
        language={language}
        setLanguage={setLanguage}
        i18n={i18n || {}}
        availableLanguages={availableLanguages}
      />
    </>
  );
}
